import { render, staticRenderFns } from "./AddTests.vue?vue&type=template&id=14c86712&scoped=true&"
import script from "./AddTests.vue?vue&type=script&lang=js&"
export * from "./AddTests.vue?vue&type=script&lang=js&"
import style0 from "./AddTests.vue?vue&type=style&index=0&id=14c86712&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c86712",
  null
  
)

export default component.exports